import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModalFormComponent } from '@shared/components/commons/common-modal-form/common-modal-form.component';
import { CheckboxComponent } from '@shared/controls/checkbox/checkbox.component';
import { ToUpperStrPipe } from "@shared/pipes/to-upper-str.pipe";
import { ToastrService } from 'ngx-toastr';
import { EntityType } from '@models/common/entity-type.enum';
import { ExternalSourceType } from '@models/integrations/external-source-type.enum';
import { SyncIdentitiesModel } from '@models/integrations/sync-identities-model';

@Component({
  selector: 'app-sync-identities-types-modal',
  standalone: true,
  imports: [
    CommonModalFormComponent,
    CheckboxComponent,
    FormsModule,
    ToUpperStrPipe
],
  templateUrl: './sync-identities-types-modal.component.html',
  styleUrl: './sync-identities-types-modal.component.scss'
})
export class SyncIdentitiesTypesModalComponent implements OnInit {

  @Output() confirm = new EventEmitter<SyncIdentitiesModel>();
  @Input() sourceType!: ExternalSourceType;
  @Input() entityTypes: EntityType[] = [];

  EntityType = EntityType;
  ExternalSourceType = ExternalSourceType;

  #activeModal = inject(NgbActiveModal);
  #toastr = inject(ToastrService);

  isLoading = false;
  typeList: { name: string, value: EntityType, checked: boolean }[] = [];

  public sourceTypeName = ExternalSourceType[this.sourceType]?.toUpperCase() || '';

  ngOnInit(): void {
    if(!this.entityTypes || this.entityTypes.length === 0) {
      this.entityTypes = [EntityType.Company, EntityType.Individual, EntityType.Trust];
    }

    this.typeList = this.entityTypes.map(type => ({
      name: EntityType[type],
      value: type,
      checked: true
    }));
  }

  sync() {
    const selectedTypes = this.typeList.filter(type => type.checked).map(type => type.value);
    if (selectedTypes.length === 0) {
      this.#toastr.error('Please select at least one type to sync', 'Error');
      return;
    }

    this.isLoading = true;
    this.#toastr.info(`The data synchronisation with ${ExternalSourceType[this.sourceType]} is in progress.`, 'Syncing');

    const syncIdentitiesModel = {
      typesToSync: selectedTypes,
      compare: true
    } as SyncIdentitiesModel;

    this.confirm.emit(syncIdentitiesModel);
    this.isLoading = false;
    this.#activeModal.close();
  }

  onClose() {
    this.#activeModal.close();
  }

}
